/**
 * Format Utils - 格式化工具函数
 */

/**
 * 格式化数字（大数字转换为 K/M 格式）
 */
export function formatNumber(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M'
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K'
  }
  return num.toString()
}

/**
 * 格式化日期（YYYY.MM.DD -> 2026.06.12）
 */
export function formatDate(dateStr: string): string {
  // 已经是 YYYY.MM.DD 格式，直接返回
  if (/^\d{4}\.\d{2}\.\d{2}$/.test(dateStr)) {
    return dateStr
  }
  // 其他格式尝试转换
  try {
    const date = new Date(dateStr)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}.${month}.${day}`
  } catch {
    return dateStr
  }
}

/**
 * 格式化日期为显示格式
 */
export function formatDateDisplay(dateStr: string): string {
  // YYYY.MM.DD -> MM.DD
  if (/^\d{4}\.\d{2}\.\d{2}$/.test(dateStr)) {
    const parts = dateStr.split('.')
    return `${parts[1]}.${parts[2]}`
  }
  return dateStr
}

/**
 * 生成推文链接
 */
export function getTweetLink(tweetId: string, screenName?: string): string {
  const username = screenName || 'i' // 默认用户名
  return `https://twitter.com/${username}/status/${tweetId}`
}

/**
 * 截断文本
 */
export function truncateText(text: string, maxLength: number): string {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

/**
 * 格式化互动数字显示
 */
export function formatEngagement(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M'
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K'
  }
  return num.toString()
}

/**
 * 格式化百分比
 */
export function formatPercent(num: number): string {
  return (num * 100).toFixed(1) + '%'
}

/**
 * 格式化置信度
 */
export function formatConfidence(num: number): string {
  return (num * 100).toFixed(0) + '%'
}
